import {Component, EventEmitter, OnInit, ViewEncapsulation} from '@angular/core';
import {IToolCommandItemButton, MagicLinkModel} from '@shared/models/platform-tool-models';
import {PlatformCommand} from '@shared/commands/command-base';
import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';

@Component({
    standalone: false,
    selector: 'app-platform-tool-country-pair-selector-button',
  templateUrl: './platform-tool-country-pair-selector-button.component.html',
  styleUrls: ['./platform-tool-country-pair-selector-button.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PlatformToolCountryPairSelectorButtonComponent implements OnInit, IToolCommandItemButton {
  clicked: EventEmitter<any>;
  command: PlatformCommand;
  handler: IPlatformToolHandler;
  magicLinkModel: MagicLinkModel;
  constructor() { }

  ngOnInit(): void {
  }

  countryOneClicked(command: PlatformCommand) {
    this.executeCommand(command);
  }

  countryTwoClicked(command: PlatformCommand) {
    this.executeCommand(command);
  }

  cancelClicked(command: PlatformCommand) {
    command.fieldValues['CountryPairCrossButtonClicked'] = true;
    this.executeCommand(command);
  }

  executeCommand(command: PlatformCommand) {
    this.clicked.emit(command);
  }

}
